// Utilidades de la pestaña «Campañas» (spec de campañas, §2 y §10).

import { getZonedParts } from './dates';
import { extractTokens, NAMED_VAR_RE } from './templateVars';

const FORMATOS_CABECERA = ['IMAGE', 'VIDEO', 'DOCUMENT'];
const ETIQUETA_CABECERA = { IMAGE: 'imagen', VIDEO: 'vídeo', DOCUMENT: 'documento' };
const MS_DIA = 24 * 60 * 60 * 1000;
const DIAS_MAX_CABECERA = 29;

export const ACCEPT_CABECERA = {
  IMAGE: 'image/jpeg,image/png',
  VIDEO: 'video/mp4,video/3gpp',
  DOCUMENT: 'application/pdf',
};

/** `'IMAGE' | 'VIDEO' | 'DOCUMENT'`, o `null` si la plantilla no lleva cabecera multimedia. */
export const formatoCabecera = (plantilla) => {
  const header = (plantilla?.components || []).find((c) => (c.type || '').toUpperCase() === 'HEADER');
  const formato = (header?.format || '').toUpperCase();
  return FORMATOS_CABECERA.includes(formato) ? formato : null;
};

export const textoCabecera = (formato, nombre) => {
  const etiqueta = ETIQUETA_CABECERA[formato];
  if (!etiqueta) return null;
  return nombre ? `Cabecera: ${etiqueta} (${nombre})` : `Cabecera: ${etiqueta}`;
};

const instanteLocal = (texto, zona) => {
  const partes = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(texto || '');
  if (!partes) return null;
  const deseado = [Number(partes[1]), Number(partes[2]), Number(partes[3]), Number(partes[4]), Number(partes[5])];
  let utc = Date.UTC(deseado[0], deseado[1] - 1, deseado[2], deseado[3], deseado[4]);
  for (let i = 0; i < 2; i += 1) {
    const visto = getZonedParts(new Date(utc), zona);
    const comoUtc = Date.UTC(visto.year, visto.month - 1, visto.day, visto.hour, visto.minute);
    const objetivo = Date.UTC(deseado[0], deseado[1] - 1, deseado[2], deseado[3], deseado[4]);
    utc += objetivo - comoUtc;
  }
  return utc;
};

/** La fecha local, leída en `zona`, cae más de 29 días después de `ahora`. */
export const programacionDemasiadoLejana = (fecha, zona, ahora) => {
  const instante = instanteLocal(fecha, zona);
  if (instante == null) return false;
  return instante > ahora.getTime() + DIAS_MAX_CABECERA * MS_DIA;
};

export const ZONA_POR_DEFECTO = 'Europe/Madrid';

const tieneUrlConVariable = (componente) =>
  (componente.buttons || []).some(
    (b) => (b.type || '').toUpperCase() === 'URL' && (b.url || '').includes('{{')
  );

/**
 * Apta para campañas (§2): aprobada, cabecera de texto o multimedia (imagen,
 * vídeo o documento), sin botón de URL con variable y con variables con nombre
 * o ninguna. El backend lo vuelve a comprobar al analizar.
 */
export const esPlantillaApta = (plantilla) => {
  if ((plantilla?.status || '').toUpperCase() !== 'APPROVED') return false;
  const textos = [];
  for (const componente of plantilla.components || []) {
    const tipo = (componente.type || '').toUpperCase();
    if (tipo === 'HEADER') {
      const formato = (componente.format || '').toUpperCase();
      if (formato === 'TEXT') textos.push(componente.text);
      else if (!FORMATOS_CABECERA.includes(formato)) return false;
    } else if (tipo === 'BODY') {
      textos.push(componente.text);
    } else if (tipo === 'BUTTONS' && tieneUrlConVariable(componente)) {
      return false;
    }
  }
  return textos.flatMap(extractTokens).every((t) => NAMED_VAR_RE.test(t));
};

export const ESTADOS_CAMPANA = {
  PROGRAMADA: 'Programada',
  ENVIANDO: 'Enviando',
  COMPLETADA: 'Completada',
  CANCELADA: 'Cancelada',
  FALLIDA: 'Fallida',
};

export const ESTADOS_DESTINATARIO = {
  PENDIENTE: 'Pendiente',
  ENVIANDO: 'Enviando',
  ENVIADO: 'Enviado',
  FALLIDO: 'Fallido',
  DESCONOCIDO: 'Desconocido',
};

/** `2026-10-20T09:30:00` → `2026-10-20 09:30`. */
export const fechaLocal = (texto) => (texto ? String(texto).replace('T', ' ').slice(0, 16) : '');

export const hayEnviando = (campanas) => campanas.some((c) => c.estado === 'ENVIANDO');

/** El texto de un `ProblemDetail`, o la reserva si no lo trae. */
export const mensajeDeProblema = (data, reserva) => data?.detail || data?.title || reserva;

let contador = 0;
export const nuevaClaveIdempotencia = () => {
  contador += 1;
  return `campana-${Date.now()}-${contador}-${Math.random().toString(36).slice(2)}`;
};
